import {CloseSquare, MinusSquare, PlusSquare} from "../../../../../ApplicationTree/Tree/TreeUtils";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {TreeView} from "@material-ui/lab";
import TreeItem from "./TreeItem";

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        flexGrow: 1,
        maxWidth: 350,
        width: '100%'
    },
    container: {
        padding: 10,
        width: '100%'
    }
}))

const Tree = (props) => {
    const {path, index, component: {children = []}} = props;
    const classes = useStyles();
    const [rootItem, childItem] = children;
    return(
        <>
            <TreeView
                className={classes.root}
                defaultExpanded={['0']}
                defaultCollapseIcon={<MinusSquare/>}
                defaultExpandIcon={<PlusSquare/>}
                defaultEndIcon={<CloseSquare/>}
                // expanded={expanded}
                // selected={selectedNodes}
                // onNodeToggle={handleToggle}
                // onNodeSelect={handleSelect}
            >
                <TreeItem
                    component={rootItem}
                    parentIndex={index}
                    path={path + '.children.' + '0'}
                    label={'Root'}
                    nodeId="0">
                    <TreeItem
                        component={childItem}
                        parentIndex={index}
                        path={path + '.children.' + '1'}
                        label={'Child'}
                        nodeId="1"
                    />
                </TreeItem>
            </TreeView>
        </>
    )

}

export default Tree;
